/**
 * Layout classes the primitives' props cannot express (viewport height,
 * fixed column width, top rule, decorative blurs). Colours use theme tokens.
 */

export const shellRootClassName = 'h-dvh';

export const shellColumnClassName = 'lg:w-[620px] lg:shrink-0';

export const logoClassName = 'size-7';

export const eyebrowClassName = 'tracking-widest';

export const shellMainClassName = 'min-h-0 flex-1';

export const shellFooterClassName = 'border-border border-t';

export const illustrationPanelClassName = 'flex-1';

export const illustrationGlowClassName = 'bg-primary/10 blur-[80px]';

export const illustrationGlowTopClassName = 'top-[18%] left-[22%] size-[420px]';

export const illustrationGlowBottomClassName = 'right-[8%] bottom-[6%] size-[300px]';
